<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="invoiceApplications"
        @reset="resetHandle"
        @delete="deleteHandle">
      <slot slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="scope.row.status === 0 || scope.row.status === 20"
            type="primary"
            @click="editHandle(scope.row)"
        >
          编辑
        </el-button>
        <el-button
            v-if="scope.row.status === 0 || scope.row.status === 20"
            type="primary"
            @click="updateStatus(scope.row, 10)">
          提交
        </el-button>
        <el-button v-if="limits.invoiceAuth && scope.row.status === 10" :loading="createInvoiceLoading" type="primary" @click="submit(scope.row)">
          开票
        </el-button>
        <el-button v-if="limits.invoiceAuth && scope.row.status === 30 && scope.row.invoiceStatus === '1' && scope.row.cancelSign === false" type="danger" @click="getCancel(scope.row)">
          冲销
        </el-button>
        <el-button
            v-if="scope.row.status === 10"
            type="danger"
            @click="updateStatus(scope.row, 20)">
          驳回
        </el-button>
      </slot>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model="filter.salesOrderNO" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" clearable placeholder="请选择状态">
                <el-option label="全部" value=""/>
                <el-option label="草稿" value="0"/>
                <el-option label="已提交" value="10"/>
                <el-option label="已驳回" value="20"/>
                <el-option label="已开票" value="30"/>
                <el-option label="已冲销" value="40"/>
              </el-select>
            </el-form-item>
            <el-form-item label="开票申请编号">
              <el-input v-model="filter.invoiceApplicationNo" placeholder="请输入开票申请编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="客户编号">
              <el-input v-model="filter.customerNo" placeholder="请输入客户编号" clearable/>
            </el-form-item>
            <el-form-item label="客户税号">
              <el-input v-model="filter.invoiceVATNO" placeholder="请输入客户税号" clearable/>
            </el-form-item>
            <el-form-item label="标识">
              <el-select v-model="filter.sign" clearable placeholder="请选择标识">
                <el-option label="全部" value=""/>
                <el-option label="财务" value="财务"/>
                <el-option label="销售" value="销售"/>
              </el-select>
            </el-form-item>
            <el-form-item label="财务凭证号">
              <el-input v-model="filter.financialVouchers" placeholder="请输入财务凭证号" clearable/>
            </el-form-item>
            <el-form-item label="SAP发票号">
              <el-input v-model="filter.sapInvoiceNo" placeholder="请输入SAP发票号" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="提交时间">
              <el-date-picker
                  v-model="submitTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitTimeRange', 'submitTimeBegin', 'submitTimeEnd')"/>
            </el-form-item>
            <el-form-item label="通过时间">
              <el-date-picker
                  v-model="passTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
            </el-form-item>
            <el-form-item label="申请人">
              <el-input v-model="filter.creatorName" placeholder="请输入申请人" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "InvoiceListApplicationList",
    components: {ViewTable},
    data() {
      return {
        selection: [],
        limits: {
          addAuth: this.$auth(319),
          // editAuth: this.$auth(7),
          delAuth: this.$auth(321),
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(8),
          downLoadAuth: this.$auth(369),
          invoiceAuth: this.$auth(291),
          chongqiaoAuth: this.$auth(320),
          rejectAuth: this.$auth(51),
        },
        createInvoiceLoading:false,
        passAuth: this.$auth(435),
        createTime: "",
        submitTime: "",
        passTime: "",
        createTimeRange: [],
        submitTimeRange: [],
        passTimeRange: [],
        filter: {
          factoryNo: "",
          status: "",
          invoiceApplicationNo: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          sign: "",
          financialVouchers: "",
          sapInvoiceNo: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
        columnsProperty: [
          {
            key: "invoiceApplicationNo",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/InvoiceApplicationPreview",
                        query: {
                          billId: params.row.pkId,
                          $tabName: params.row.invoiceApplicationNo,
                          selection: [],
                        },
                      });
                    },
                  },
                },
                params.row.invoiceApplicationNo,
              );
            },
          },
          {
            key: "customerName",
            width: 200,
            align: "center",
          },
          {
            key: "createTime",
            width: 180,
            align: "center",
          },
          {
            key: "submitTime",
            width: 180,
            align: "center",
          },
          {
            key: "passTime",
            width: 180,
            align: "center",
          },
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "creatorName",
            align: "center",
            width: 160,
          },
          {
            key: "invoiceTotalAmount",
            align: "center",
            width: 160,
          },
          {
            key: "customerNo",
            align: "center",
            width: 160,
          },
          {
            key: "invoiceVATNO",
            align: "center",
            width: 160,
          },
          {
            key: "sign",
            align: "center",
            width: 160,
          },
          {
            key: "financialVouchers",
            align: "center",
            width: 160,
          },
          {
            key: "sapInvoiceNo",
            align: "center",
            width: 160,
            ellipsis: true,
            tooltip: true,
          },
          {
            key: "note",
            align: "center",
            width: 160,
            ellipsis: true,
            tooltip: true,
          },
          {
            key: "invoiceStatus",
            align: "center",
            width: 160,
          },
          {
            key: "passTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            width: 362,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.createTimeBegin": {
        handler(newVal) {
          if (newVal) {
            this.createTimeRange = [];
            this.createTimeRange.push(this.filter.createTimeBegin);
            this.createTimeRange.push(this.filter.createTimeEnd);
          }
        },
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      goto(row) {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: row.pkid,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },
      otherAuth(row) {
        // 仅草稿与驳回可以删除
        return !(row.status === 0 || row.status === 20);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      deleteHandle(row) {
        this.$confirm("是否确认要进行删除？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.delete("basic", "invoiceApplications", row.pkId).then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("删除成功");
            }
          });
        });
      },
      updateStatus(row, status) {
        this.$confirm("是否确认要进行操作？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `invoiceApplications/updateStatus/${row.pkId}/${status}`)
            .then((resp) => {
              if (resp.success) {
                this.$message.success("更新成功");
                this.loadData(1);
              }
            });
        }).catch(() => {
          // 用户取消，不执行操作
        });
      },
      editHandle(row) {
        this.$router.push({
          path: "/InvoiceApplicationEdit",
          query: {
            billId: row.pkId,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      createTimeChange(date) {
        if (date !== null) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },

      submit(row) {
        this.$confirm("是否确认要进行操作？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.createInvoiceLoading=true;
          this.$http.get("basic", `invoiceApplications/createSapInvoice/${row.pkId}`)
            .then(resp => {
              if (resp.success) {
                this.loadData();
                this.createInvoiceLoading=false;
              }
            });
        }).catch(() => {
          // 用户取消，不执行操作
        });
      },
      cancelSapInvoice(row) {
        this.$confirm("是否确认要进行开票？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `invoiceApplications/cancelSapInvoice/${row.pkId}`)
            .then(resp => {
              if (resp.success) {
                this.loadData();
              }
            });
        }).catch(() => {
          // 用户取消，不执行操作
        });
     
      },

      submitTimeChange(date) {
        if (date !== null) {
          this.filter.submitTimeBegin = date[0];
          this.filter.submitTimeEnd = date[1];
        } else {
          this.filter.submitTimeBegin = "";
          this.filter.submitTimeEnd = "";
        }
      },

      passTimeChange(date) {
        if (date !== null) {
          this.filter.passTimeBegin = date[0];
          this.filter.passTimeEnd = date[1];
        } else {
          this.filter.passTimeBegin = "";
          this.filter.passTimeEnd = "";
        }
      },

      getCancel(row) {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: 0,
            $tabName: "开票申请",
            selection: [],
            cancelId:row.pkId,
          },
        });
      },
    },
  };
</script>
